import { Box, Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import { setTransportFilterCheckedType } from 'app/actions/map';
import { useLocalStorage } from 'app/services';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const MapFilterTransportFilterList = () => {
    const dispatch = useDispatch();
    const checkedType = useSelector((state) => state.map.transportFilterCheckedType);
    const [, setTransportFilterCheckedStorageType] = useLocalStorage('transportFilterCheckedType', 'all');
    const handleChange = (event) => dispatch(setTransportFilterCheckedType(event.target.name));
    useEffect(() => {
        setTransportFilterCheckedStorageType(checkedType);
    }, [checkedType]);
    return (React.createElement(Box, { component: 'ul', sx: (theme) => ({
            display: 'flex',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '10px',
            width: '100%',
            listStyle: 'none',
            position: 'relative',
            padding: '0 12px',
            margin: theme.spacing(0),
            '.MuiFormLabel-root': {
                marginBottom: '6px',
                fontSize: '12px',
                '&.Mui-focused': {
                    color: 'text.secondary',
                },
            },
            '.MuiFormControlLabel-root': {
                userSelect: 'none',
                margin: theme.spacing(0),
                padding: theme.spacing(0),
                '.MuiCheckbox-root': {
                    padding: theme.spacing(0),
                    marginRight: '4px',
                },
            },
            '.MuiFormControlLabel-label': {
                whiteSpace: 'nowrap',
            },
        }) },
        React.createElement(FormControl, { component: 'fieldset', variant: 'standard' },
            React.createElement(FormGroup, null,
                React.createElement(FormControlLabel, { label: '\u041E\u0431\u044B\u0447\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C', control: React.createElement(Checkbox, { size: 'small', name: 'all', disableRipple: true, onChange: handleChange, checked: checkedType === 'all' }) }))),
        React.createElement(FormControl, { component: 'fieldset', variant: 'standard' },
            React.createElement(FormGroup, null,
                React.createElement(FormControlLabel, { label: '\u0420\u0435\u0436\u0438\u043C \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438', control: React.createElement(Checkbox, { size: 'small', name: 'filter', disableRipple: true, onChange: handleChange, checked: checkedType === 'filter' }) })))));
};
export default MapFilterTransportFilterList;
